import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=1fa4e0bc"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=1fa4e0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports